import { createSelector } from '@reduxjs/toolkit'
import { IPortal } from './reducer'

const rootState = (state: IPortal) => state.portal

export const getIsUnitsModalOpen = createSelector(
  rootState,
  (state) => state.isUnitsModalOpen
)

export const getConfirmCancel = createSelector(
  rootState,
  (state) => state.confirmCancel
)
